import React from "react";
import { Box, Typography, Link, Grid2 } from "@mui/material";
import styles from "./RewardsPageFooterSection.module.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import StarIcon from "../../components/icon-components/StarIcon";
import QuestionIllustration from "../../components/icon-components/QuestionIllustration";
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { getPatientRoute } from "../../utility/functions/common-functions";
import { useAppSelector } from "../../store/hooks";

const RewardsPageFooterSection: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    patientProfileInfo: { patientProfileId },
  } = useAppSelector((state) => state.patientProfileDetails);
  const handleFaqClick = () => {
    navigate("/patient/faq");
  };

  return (
    <Box className={styles.wrapper}>
      <Grid2 container spacing={2.5} sx={{ alignItems: "stretch" }}>
        <Grid2 size={{ xs: 12, md: 7 }} className={styles.cardPrimary}>
          <StarIcon />
          <Typography
            variant="h4"
            className={styles.title}
          >
            {t("myRewardsPage.earnTitle")}
          </Typography>
          <Typography
            variant="body1"
            className={styles.description}
          >
            {t("myRewardsPage.earnDescription")}
          </Typography>
          <CustomButton
            variant="contained"
            onClick={() =>
              navigate(getPatientRoute(patientProfileId, "/care-plan"))
            }
            text={t("myRewardsPage.earnCta")}
          />
        </Grid2>

        <Grid2
          size={{ xs: 12, md: 5 }}
          className={styles.cardSecondary}
        >
          <QuestionIllustration />
          <Typography
            variant="h4"
            className={styles.title}
            px={4}
          >
            {t("myRewardsPage.faqTitle")}
          </Typography>
          <Typography
            variant="body1"
            className={styles.description}
          >
            {t("myRewardsPage.faqDescription")}{" "}
            <Link
              onClick={handleFaqClick}
              role="link"
              underline="hover"
              sx={{
                cursor: "pointer",
              }}
            >
              {t("myRewardsPage.faqLink")}
            </Link>
          </Typography>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default RewardsPageFooterSection;
